<template>
  <Dashboard>
    <template v-slot:title>
      <h2>{{$t("users.title")}}</h2>
    </template>
    <template v-slot:filter>
      <div class="relative">
        <button
          @click="show.filter = !show.filter"
          class="outline"
        >
          <i class="fas fa-filter fa-flip-horizontal"></i>
          {{$t("button.filter")}}
        </button>
        <Filtres
          :options="options"
          :users="users"
          v-if="show.filter"
          @wipe="wipeFilter()"
          @filter="getFilter"
        ></Filtres>
      </div>
    </template>
    <template
      v-slot:buttonRight
      v-if="$store.getters.USERPROFILE['user-invitation']||$store.getters.USERPROFILE['user-administration']"
    >
      <button @click="show.add = true">
        <i class="fas fa-plus"></i>
        {{$t("button.newUser")}}
      </button>
      <Add
        v-if="show.add"
        @close="show.add = false"
        @get="getUsers()"
      ></Add>
    </template>
    <template v-slot:tab>
      <thead>
        <tr class="trHead">
          <th
            v-for="item in tab"
            :key="item.title"
            class="accentuate"
          >
            <div class="row">
              {{item.title}}
              <div class="column sort">
                <i
                  v-if="sort.order == -1  && item.sort==sort.type "
                  class="fas fa-sort-up up blueColor"
                  @click="(sort.type = item.sort) && (sort.order = 1)"
                ></i>
                <i
                  v-else-if="sort.order == 1 && item.sort==sort.type"
                  class="fas fa-sort-down down blueColor"
                  @click="(sort.type = item.sort) && (sort.order = -1)"
                ></i>
                <i
                  v-else-if="sort.order == 1|| item.sort!=sort.type"
                  class="fas fa-sort-down down"
                  @click="(sort.type = item.sort) && (sort.order = -1)"
                ></i>
              </div>
            </div>
          </th>
          <th>
          </th>
          <th>
          </th>
          <th v-if="$store.getters.USERPROFILE['user-administration']"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="data in sortUsers"
          :key="data.title"
        >
          <td>{{data['first-name']}} {{data['name']}}</td>
          <td>{{data.email}}</td>
          <td>{{data.company}}</td>
          <td>{{data['phone-number']}}</td>
          <td>{{data['user-profile-name']}}</td>
          <td>{{ $t('users.thereIs')}} {{ getLastConnexion(data['last-logging-date']) }}</td>
          <td>
            <span
              class="comments"
              v-if="data['archived']"
            >
              {{$t('users.userRevoked')}}&nbsp;
            </span>
            <span
              class="comments"
              v-if="data['user-profile-archived']"
            >
              {{$t('users.userProfileArchived')}}&nbsp;
            </span>
          </td>
          <td>
            <p
              class="chip grey"
              v-if="data['archived']||data['user-profile-archived']"
            >{{$t("users.isRevoked")}}</p>
          </td>
          <td
            class="bubbleParent"
            v-if="changeAllowed(data)"
          >
            <button
              ref="bubble"
              class="outline"
              @click="bubbleClick(data.id)"
            >
              <img
                ref="bubble"
                class="pastille"
                src="@/assets/images/pastille.png"
                alt="pastille"
              >
            </button>
            <div
              class="bubble"
              v-if="bubbleAction(data.id)"
            >
              <a @click="show.update=true;currenUserId=data.id">{{$t('users.modifyUser')}}</a>
              <a
                class="textRed"
                v-if="!data['archived']"
                @click="prepareArchive(data)"
              >{{$t('users.revokeUser')}}</a>
              <a
                v-if="data['archived']"
                @click="archive(data)"
              >{{$t('users.unarchive')}}</a>
            </div>
          </td>
        </tr>
        <ModifyInBox
          v-if="show.update"
          :parUserId="currenUserId"
          @userchanged="getUsers"
          @close="show.update=false"
        >
        </ModifyInBox>
        <ConfirmationBox
          v-if="show.confirm"
          :parData="confirmationData"
          @continueprocess="continueProcess"
          @close="show.confirm=false"
        >
        </ConfirmationBox>
      </tbody>
    </template>

  </Dashboard>
</template>

<script>
import Dashboard from "@/components/layout/Dashboard";
import Add from "@/components/users/add/UserData";
import Filtres from "@/components/users/Filtres";
import Users from "@/services/Users";
import compare from "@/mixins/compare";
import bubble from "@/mixins/bubble";
import ModifyInBox from "@/components/users/ModifyInBox";
import ConfirmationBox from "@/mixins/ConfirmationBox";
export default {
  components: {
    Dashboard,
    Add,
    Filtres,
    ModifyInBox,
    ConfirmationBox
  },
  data() {
    return {
      currenUserId: "",
      confirmationData: {
        cancel: this.$t('button.cancel'),
        data:{},
        description: this.$t('users.confirmArchiveDescription'),
        proceedButton:this.$t('button.confirmArchiveUser'),
        process: "",
        title: ""
      },
      show: {
        add: false,
        filter: false,
        update: false,
        confirm: false
      },
      options: {
        roleName: {},
        enterpriseName: {}
      },
      sort: {
        order: -1,
        type: "last-logging-date"
      },
      users: []
    };
  },
  mounted() {
    this.getUsers();
  },
  computed: {
    tab() {
      return [
        { title: this.$t("users.user"), sort: "first-name" },
        { title: this.$t("users.email"), sort: "email" },
        { title: this.$t("users.enterprise"), sort: "company" },
        { title: this.$t("users.phoneNumber"), sort: "phone-number" },
        { title: this.$t("users.role"), sort: "user-profile-name" },
        { title: this.$t("users.lastConnexion"), sort: "last-logging-date" }
      ];
    },
    filterUsers: function() {
      return this.users.filter(user => {
        if (Object.keys(this.options.roleName).length == 0) {
          return this.filterCompany(user);
        } else {
          let role = this.options.roleName[user["user-profile-name"]];
          if (role && role == true) {
            return this.filterCompany(user);
          } else {
            return false;
          }
        }
      });
    }
  },
  mixins: [compare, bubble],
  methods: {
    prepareArchive(data) {
      this.confirmationData.data=data
      this.confirmationData.process = "archiveUser"
      this.confirmationData.title = this.$t("users.confirmArchiveTitle") +" "+data['first-name']+" " +data['name']+" ("+data['email']+")" 
      this.show.confirm=true
    },
    continueProcess(data) {
      switch (data.process) {
        case "archiveUser":
          this.archive(data.data);
          break;
        default:
          break;
      }
    },
    filterCompany(user) {
      if (Object.keys(this.options.enterpriseName).length == 0) {
        return true;
      } else {
        let enterprise = this.options.enterpriseName[user.company];
        if (enterprise && enterprise == true) {
          return true;
        } else {
          return false;
        }
      }
    },
    getLastConnexion(date) {
      var start = this.moment(Date.now());
      var end = this.moment(date);
      return end.from(start, true);
    },
    getUsers() {
      Users.getUsers().then(res => {
        switch (res.status) {
          case 200:
            this.users = res.data;
            break;
          case 401:
            this.$router.push({ name: "noAccess" });
            break;
          default:
            this.$router.push({ name: "noService" });
            break;
        }
      });
    },
    changeAllowed(data) {
      if (
        (this.$store.getters.USERPROFILE["user-administration"] &&
          this.$store.getters.USERPROFILE["user-profile-administration"]) ||
        (this.$store.getters.USERPROFILE["user-administration"] &&
          !this.$store.getters.USERPROFILE["user-profile-administration"] &&
          data["default-profile"])
      )
        return true;
      return false;
    },

    wipeFilter() {
      this.show.filter = false;
      this.options = {
        roleName: {},
        enterpriseName: {}
      };
    },
    getFilter(data) {
      this.options = data;
      this.show.filter = false;
    },
    archive(data) {
      data.archived = !data.archived;
      Users.partialUpdate(data.id, { archived: data.archived }).then(res => {
        if (res.status == 204) {
          this.getUsers();
        } else {
          console.log("Error: Impossible to archive");
        }
      });
    }
  }
};
</script>

<style scoped>
.sort {
  position: relative;
  margin-right: 5px;
}
.sort i {
  position: absolute;
}
.down {
  top: -15px;
  left: 5px;
}
.up {
  top: -10px;
  left: 5px;
}
</style>